import { TipoEstacaoMeteorologicaEnum } from 'app/shared/enums';

export class EstacaoMeteorologicaUnidadeModel {
    arquivado: boolean;
    equipamento_ref: number;
    id: number;
    nome: string;
    tipo: TipoEstacaoMeteorologicaEnum;
}
